<section class="profile-wrapper">
  <page-header></page-header>
  <main class="profile-wrapper__content">
    <ng-content></ng-content>
  </main>
</section>
